// Footer events (analytics sheet → "Footer" section).
import {logAnalyticsEvent} from './analytics';
import type {ContactMethodClickParams, SocialMediaLinksClickParams} from './events';
import {AnalyticsEntryPoint} from './events';

const ENTRY_POINT = AnalyticsEntryPoint.Footer;

export function trackFooterTabClick(tabName: string, tabId?: string) {
  logAnalyticsEvent('footer_tab_click', {
    entry_point: ENTRY_POINT,
    tab_name: tabName,
    tab_id: tabId,
  });
}

export function trackFooterContactMethodClick(method: ContactMethodClickParams['item_type']) {
  logAnalyticsEvent('contact_method_click', {
    entry_point: ENTRY_POINT,
    item_type: method,
  });
}

export function trackFooterSocialMediaClick(network: SocialMediaLinksClickParams['item_type']) {
  logAnalyticsEvent('social_media_links_click', {
    entry_point: ENTRY_POINT,
    item_type: network,
  });
}
